import { feature } from 'topojson-client';
import {
  mergeDataGeo,
  saveDataGeo,
  changeCurrentKey,
  changeCurrentScale,
} from '../../actions/index';
import store from '../../store';
import startEvents from './events';
import renderMap from './render';
import renderLegend from './legend';
// import { append } from '../../helpers/append';

// CSS
import './loading.scss';
import './mapa.scss';

const { dispatch, getState } = store;

function order(item) {
  return {
    ...item,
    candidatos: [
      ...item.candidatos.sort((a, b) => (
        parseInt(b.total_votos_validos.replace(/\D/g, ''), 10) -
        parseInt(a.total_votos_validos.replace(/\D/g, ''), 10)
      )),
    ],
  };
}

export default function createMap({ NEWDATA, MAP }) {
  const todosMunicipios = feature(MAP, MAP.objects.tracts);
  const todosEstados = feature(MAP, MAP.objects.ufs);
  const { features } = todosEstados;

  // UF DO RIO - GEO
  const estados = features.find(({ id }) => id === '35');

  // MUNICIPIOS DO RIO - GEO
  const municipios = todosMunicipios.features.filter(({ properties }) => properties.uf === 'SP');

  // MERGE GEO + DADO
  const newMunicipios = municipios.map((e) => {
    const { id } = e;
    const item = NEWDATA.municipios[id];
    return {
      ...e, ...{ dadosMunicipio: order(item) },
    };
  });

  // 'GRAVA' O MERGE e GEO
  dispatch(mergeDataGeo(newMunicipios));
  dispatch(saveDataGeo({
    municipios,
    estados,
  }));

  // INICIAR COM ESSES PARAMETROS (KEY, SCALE)
  console.log('@@@ INICIO');
  const { initial } = getState();
  const { scales } = initial;
  const { scaleCandidatos } = scales;

  dispatch(changeCurrentKey({
    key: 'candidatos',
    target: 'id_candidato',
    type: null,
    tooltip: 'candidatos',
  }));

  dispatch(changeCurrentScale(scaleCandidatos()));
  console.log('@@@ RENDER MAPA');
  renderMap();
  console.log('@@@ RENDER LEGENDA');
  renderLegend();
  console.log('@@@ START EVENTS');
  startEvents();
}



// WEBPACK FOOTER //
// ./src/components/mapa/index.js